import Vue from 'vue'

Vue.component('Downloads', {
  template: '#vue-downloads-template',
  props: ['linkIcon', 'linkText', 'icon', 'text', 'fileUrl'],
})
